(function() {
  "use strict";

  /**
   * Easy selector helper function
   */
  const select = (el, all = false) => {
    el = el.trim()
    if (all) {
      return [...document.querySelectorAll(el)]
    } else {
      return document.querySelector(el)
    }
  }

  /**
   * Easy event listener function
   */
  const on = (type, el, listener, all = false) => {
    let selectEl = select(el, all)
    if (selectEl) {
      if (all) {
        selectEl.forEach(e => e.addEventListener(type, listener))
      } else {
        selectEl.addEventListener(type, listener)
      }
    }
  }

  /**
   * Easy on scroll event listener 
   */
  const onscroll = (el, listener) => {
    el.addEventListener('scroll', listener)
  }

  /**
   * Navbar links active state on scroll
   */
  let navbarlinks = select('#navbar .scrollto', true)
  const navbarlinksActive = () => {
    let position = window.scrollY + 200
    navbarlinks.forEach(navbarlink => {
      if (!navbarlink.hash) return
        let section = select(navbarlink.hash)
      if (!section) return
        if (position >= section.offsetTop && position <= (section.offsetTop + section.offsetHeight)) {
          navbarlink.classList.add('active')
        } else {
          navbarlink.classList.remove('active')
        }
      })
  }
  window.addEventListener('load', navbarlinksActive)
  onscroll(document, navbarlinksActive)

  /**
   * Scrolls to an element with header offset
   */
  const scrollto = (el) => {
    let header = select('#header')
    let offset = header.offsetHeight

    let elementPos = select(el).offsetTop
    window.scrollTo({
      top: elementPos - offset,
      behavior: 'smooth'
    })
  }

  /**
   * Toggle .header-scrolled class to #header when page is scrolled
   */
  let selectHeader = select('#header')
  if (selectHeader) {
    const headerScrolled = () => {
      if (window.scrollY > 100) {
        selectHeader.classList.add('header-scrolled')
      } else {
        selectHeader.classList.remove('header-scrolled')
      }
    }
    window.addEventListener('load', headerScrolled)
    onscroll(document, headerScrolled)
  }

  /**
   * Back to top button
   */
  let backtotop = select('.back-to-top')
  if (backtotop) {
    const toggleBacktotop = () => {
      if (window.scrollY > 100) {
        backtotop.classList.add('active')
      } else {
        backtotop.classList.remove('active')
      }
    }
    window.addEventListener('load', toggleBacktotop)
    onscroll(document, toggleBacktotop)
  }

  /**
   * Mobile nav toggle
   */
  on('click', '.mobile-nav-toggle', function(e) {
    select('#navbar').classList.toggle('navbar-mobile')
    this.classList.toggle('bi-list')
    this.classList.toggle('bi-x')
  })

  /**
   * Mobile nav dropdowns activate
   */
  on('click', '.navbar .dropdown > a', function(e) {
    if (select('#navbar').classList.contains('navbar-mobile')) {
      e.preventDefault()
      this.nextElementSibling.classList.toggle('dropdown-active')
    }
  }, true)

  /**
   * Scrool with ofset on links with a class name .scrollto
   */
  on('click', '.scrollto', function(e) {
    if (select(this.hash)) {
      e.preventDefault()

      let navbar = select('#navbar')
      if (navbar.classList.contains('navbar-mobile')) {
        navbar.classList.remove('navbar-mobile')
        let navbarToggle = select('.mobile-nav-toggle')
        navbarToggle.classList.toggle('bi-list')
        navbarToggle.classList.toggle('bi-x')
      }
      scrollto(this.hash)
    }
  }, true)

  /**
   * Scroll with ofset on page load with hash links in the url
   */
  window.addEventListener('load', () => {
    if (window.location.hash) {
      if (select(window.location.hash)) {
        scrollto(window.location.hash)
      }
    }
  });


const searchbus = document.getElementById("searchbus");
    if (searchbus) {
    
function createBusCard(bus) {
    const cardDiv = document.createElement("div");
    cardDiv.className = `cardbus card`;
    cardDiv.style.border = "none";
    const link = document.createElement("a");
    link.href = `/Vehicule/${bus.id}/${bus.marque_name} ${bus.model}.html`;
    const badgeSpan = document.createElement("span");
    badgeSpan.className = "card-notify-badge";
    if (bus.statut === "VENDU") badgeSpan.style.backgroundColor = "red";
    if (bus.statut === "SUR PARC") badgeSpan.style.backgroundColor = "green";
    if (bus.statut === "A VENIR") badgeSpan.style.backgroundColor = "orange";
    badgeSpan.innerHTML = `<div>${bus.statut}</div>`;
    if (bus.web_heart) {
        badgeSpan.innerHTML += `
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-through-heart-fill" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M2.854 15.854A.5.5 0 0 1 2 15.5V14H.5a.5.5 0 0 1-.354-.854l1.5-1.5A.5.5 0 0 1 2 11.5h1.793l3.103-3.104a.5.5 0 1 1 .708.708L4.5 12.207V14a.5.5 0 0 1-.146.354l-1.5 1.5ZM16 3.5a.5.5 0 0 1-.854.354L14 2.707l-1.006 1.006c.236.248.44.531.6.845.562 1.096.585 2.517-.213 4.092-.793 1.563-2.395 3.288-5.105 5.08L8 13.912l-.276-.182A23.825 23.825 0 0 1 5.8 12.323L8.31 9.81a1.5 1.5 0 0 0-2.122-2.122L3.657 10.22a8.827 8.827 0 0 1-1.039-1.57c-.798-1.576-.775-2.997-.213-4.093C3.426 2.565 6.18 1.809 8 3.233c1.25-.98 2.944-.928 4.212-.152L13.292 2 12.147.854A.5.5 0 0 1 12.5 0h3a.5.5 0 0 1 .5.5v3Z"/>
            </svg>`;
    }
    if (bus.web_ba) {
        badgeSpan.innerHTML += `
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-emoji-smile-fill" viewBox="0 0 16 16">
                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zM4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM10 8c-.552 0-1-.672-1-1.5S9.448 5 10 5s1 .672 1 1.5S10.552 8 10 8z"/>
            </svg>`;
    }
    const yearSpan = document.createElement("span");
    yearSpan.className = "card-notify-year";
    yearSpan.textContent = bus.year;
    const cardbus = document.createElement("div");
    cardbus.className = "cardbus-card-4 text-center";
    const imageContainer = document.createElement("div");
    imageContainer.style = "position: relative;min-height:444px;max-width:350px;";
    const img = document.createElement("img");
    img.src = bus.img ? `/Vehicule/img/P${bus.img}_${bus.pic_clef}.jpeg` : "/Vehicule/ccp.jpeg";
    // img.className = "img img-responsive";
    imageContainer.appendChild(img);
    const contentDiv = document.createElement("div");
    contentDiv.className = "cardbus-content";
    contentDiv.innerHTML = `
        <div class="cardbus-name">${bus.marque_name}</div>
        <div class="cardbus-description">
            <span class="model">${bus.type_name} ${bus.model}</span><br><br>
            PLACES : ${bus.FiscalPlace} CG - couchage : ${bus.sleeping}<br>
            TAILLE : ${bus.dim_length}L x ${bus.dim_width}l x ${bus.dim_height}H<br>
            ${bus.porteur_name ? `MOTORISATION : ${bus.porteur_name} ${bus.cylindre_name} ${bus.porteur_cv}<br>` : ""}
            ${bus.vovn === "occasion" && bus.vovn_mileage > 0 ? `${bus.vovn_mileage.toLocaleString()} Km` : ""}
            <br>
        </div>
    `;
    const priceDiv = document.createElement("div");
    priceDiv.className = "cardbus-overview featured";
    priceDiv.innerHTML = `
        ${bus.vovn.toUpperCase()}<h4>
        ${bus.statut !== "VENDU" ? `
            ${bus.price_outcrossed ? `<span class="text-nowrap badge text-bg-secondary" style="text-decoration: line-through;">${bus.price_outcrossed.toLocaleString()} €</span>` : ""}
            ${bus.price_sold ? bus.price_sold.toLocaleString() + " €" : ""}
        ` : "VENDU"}
    </h4>`;
    contentDiv.appendChild(priceDiv);
    imageContainer.appendChild(contentDiv);
    cardbus.appendChild(imageContainer);
    link.appendChild(badgeSpan);
    link.appendChild(yearSpan);
    link.appendChild(cardbus);
    cardDiv.appendChild(link);
    return cardDiv;
}
    // Clé de stockage des filtres du moteur de recherche dans le navigateur
    const FILTERS_KEY = "andrieux:busFilters";

    // Exécute la recherche AJAX à partir des valeurs courantes du formulaire
    function runSearch() {
      const formData = new FormData(searchbus);
      const rows = document.getElementById("rowbuscard");
      if (!rows) return;
      const xhr = new XMLHttpRequest();
      xhr.open("POST", "/Vehicules", true);
      xhr.responseType = "json";
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          rows.innerHTML = '';
          xhr.response.forEach((file) => rows.appendChild(createBusCard(file)));
        }
      };
      xhr.send(formData);
    }

    // Sérialise l'état des filtres dans le localStorage
    function saveFilters() {
      const neuf = document.getElementById("btn-check");
      const occasion = document.getElementById("btn-check-2");
      const brand = document.getElementById("brand");
      const type = document.getElementById("type");
      const state = {
        neuf: neuf ? neuf.checked : false,
        occasion: occasion ? occasion.checked : false,
        brand: brand ? brand.value : "0",
        type: type ? type.value : "0",
      };
      try {
        localStorage.setItem(FILTERS_KEY, JSON.stringify(state));
      } catch (e) {
        // localStorage indisponible (mode privé, quota) : on ignore silencieusement
      }
    }

    // Restaure les filtres depuis le localStorage ; renvoie true si au moins un filtre est actif
    function restoreFilters() {
      let state = null;
      try {
        state = JSON.parse(localStorage.getItem(FILTERS_KEY));
      } catch (e) {
        return false;
      }
      if (!state) return false;
      const neuf = document.getElementById("btn-check");
      const occasion = document.getElementById("btn-check-2");
      const brand = document.getElementById("brand");
      const type = document.getElementById("type");
      if (neuf) neuf.checked = !!state.neuf;
      if (occasion) occasion.checked = !!state.occasion;
      if (brand && state.brand != null) brand.value = state.brand;
      if (type && state.type != null) type.value = state.type;
      return !!state.neuf || !!state.occasion ||
             (!!state.brand && state.brand !== "0") ||
             (!!state.type && state.type !== "0");
    }

    searchbus.addEventListener("submit", function (e) {
      e.preventDefault();
      saveFilters();
      runSearch();
    });

    // Mémorise aussi à chaque changement de filtre (sans soumission explicite)
    searchbus.addEventListener("change", saveFilters);

    // Au chargement : restaure les filtres mémorisés et relance la recherche si besoin
    if (restoreFilters()) {
      runSearch();
    }
  }



/**
 * Charge un script externe et renvoie une Promise résolue à la fin du chargement.
 * Empêche les doublons si on l'appelle plusieurs fois avec la même URL.
 */
function loadScript(src, {id, async=true, defer=true, timeout=15000, attrs={}} = {}) {
  return new Promise((resolve, reject) => {
    if (id && document.getElementById(id)) return resolve();

    const s = document.createElement('script');
    if (id) s.id = id;
    s.src = src;
    s.async = async;
    s.defer = defer;
    Object.entries(attrs).forEach(([k, v]) => s.setAttribute(k, v));

    const timer = setTimeout(() => {
      s.remove();
      reject(new Error('Timeout de chargement du script: ' + src));
    }, timeout);

    s.onload = () => { clearTimeout(timer); resolve(); };
    s.onerror = () => { clearTimeout(timer); reject(new Error('Erreur de chargement: ' + src)); };

    document.head.appendChild(s);
  });
}

// Exemple d’usage avec fallback :
// (async () => {
//   try {
//     console.log('[CookieConsent] jsDelivr');
//     await loadScript('https://cdn.jsdelivr.net/npm/@synapxlab/cookie-consent@2.1.3/dist/cookie.min.js', {
//       id: 'cookie-consent-cdn'
//     });
//   } catch (e) {
//     console.warn('[CookieConsent] jsDelivr a échoué, tentative de fallback…', e);
//     await loadScript('https://unpkg.com/@synapxlab/cookie-consent@2.1.3/dist/cookie.min.js', {
//       id: 'cookie-consent-unpkg'
//     });
//   }

//   // À ce stade, window.CookieConsent est disponible (UMD).
// // window.CookieConsent.init({
// //   logger: {
// //     enabled: true,
// //     apiKey: 'ee7d892a7b3a155df1deb91963310ea95de60f4c1119ce16ca970c991ada4267',
// //     anonymousId: true,
// //     includeUserAgent: true,
// //     headers: {
// //       'Authorization': 'Bearer apk_0b5e80fc5d7d65ab3847e64cc7315804',
// //       'X-Request-Id': crypto.randomUUID()
// //     }
// //   },
// // });
// })();




document.querySelectorAll(".viewerpdf").forEach(el => {

  // console.log('qqqqqqqqqq')

  //   el.addEventListener('click', e => {
  //       e.preventDefault(); // empêcher l'ouverture normale du lien
        
  //       const url = el.getAttribute('href'); // récupérer l'URL du fichier
  //       const fileName = url.split('/').pop(); // extraire le nom du fichier pour le titre

  //       const p = window.open("");
  //       p.document.write(`
  //           <html>
  //               <head>
  //                   <title>${fileName}</title>
  //                   <style>
  //                       body { margin: 0px; }
  //                       embed { width: 100%; height: 100%; border: 0; }
  //                   </style>
  //               </head>
  //               <body>
  //                   <embed src="${encodeURI(url)}#toolbar=1&navpanes=0&scrollbar=0" type="application/pdf">
  //               </body>
  //           </html>
  //       `);
  //   });
});










// function fadeOut(element, duration = 300) {
//     let opacity = 1; // Opacité initiale
//     const interval = 50; // Intervalle de rafraîchissement
//     const step = interval / duration; // Calcul du pas d'opacité
//     function fade() {
//         opacity -= step;
//         element.style.opacity = opacity;

//         if (opacity <= 0) {
//             element.style.display = "none"; // Cache complètement après le fondu
//             clearInterval(fading);
//         }
//     }
//     const fading = setInterval(fade, interval);
// }



    // const grid = document.querySelector('#bus-card');
    // const iso = new Isotope(grid, {
    //     itemSelector: '.card',
    //     layoutMode: 'fitRows'
    // });


    // const filters = document.querySelectorAll("#portfolio-flters li");
    // const cards = document.querySelectorAll("#bus-card .card");

    // if (!filters.length || !cards.length) return; // Vérifie que les éléments existent
    // const filters = document.querySelectorAll("#portfolio-flters li");

    // filters.forEach(filter => {
    //     filter.addEventListener("click", function () {
    //         // filters.forEach(f => f.classList.remove("active"));
    //         // this.classList.add("active");

    //         // const filterValue = this.getAttribute("data-filter");
    //         // iso.arrange({ filter: filterValue });
    //     });
    // });

    // // // Vérifie si l'élément du filtre "Tout" existe avant d'appeler .click()
    // const defaultFilter = document.querySelector("#portfolio-flters li[data-filter='filtre_all']");
    // if (defaultFilter) defaultFilter.click();




  // const glightbox = GLightbox({
  //   selector: '.glightbox'
  // });
  // let skilsContent = select('.skills-content');
  // if (skilsContent) {
  //   new Waypoint({
  //     element: skilsContent,
  //     offset: '80%',
  //     handler: function(direction) {
  //       let progress = select('.progress .progress-bar', true);
  //       progress.forEach((el) => {
  //         el.style.width = el.getAttribute('aria-valuenow') + '%'
  //       });
  //     }
  //   })
  // }
  // window.addEventListener('load', () => {
  //   let portfolioContainer = select('.portfolio-container');
  //   if (portfolioContainer) {
  //     let portfolioIsotope = new Isotope(portfolioContainer, {
  //       itemSelector: '.portfolio-item'
  //     });
  //     let portfolioFilters = select('#portfolio-flters li', true);
  //     on('click', '#portfolio-flters li', function(e) {
  //       e.preventDefault();
  //       portfolioFilters.forEach(function(el) {
  //         el.classList.remove('filter-active');
  //       });
  //       this.classList.add('filter-active');

  //       portfolioIsotope.arrange({
  //         filter: this.getAttribute('data-filter')
  //       });
  //       portfolioIsotope.on('arrangeComplete', function() {
  //         AOS.refresh()
  //       });
  //     }, true);
  //   }

  // });
  // const portfolioLightbox = GLightbox({
  //   selector: '.portfolio-lightbox'
  // });
  // new Swiper('.portfolio-details-slider', {
  //   speed: 400,
  //   loop: true,
  //   autoplay: {
  //     delay: 5000,
  //     disableOnInteraction: false
  //   },
  //   pagination: {
  //     el: '.swiper-pagination',
  //     type: 'bullets',
  //     clickable: true
  //   }
  // });



  window.addEventListener('load', () => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
      mirror: false
    });
  });


  const formContact = document.getElementById("form_contact");


  if (formContact) {
    const submitBtn = document.getElementById("submit-btn");
    const emailInput = document.getElementById("email");
    const nameInput = document.getElementById("name");
    emailInput.addEventListener("input", function () {
      emailInput.nextElementSibling.style.display = "none";
    });
    nameInput.addEventListener("input", function () {
      nameInput.nextElementSibling.style.display = "none";
    });

    formContact.addEventListener("submit", function (event) {
      event.preventDefault();
      document.querySelectorAll(".invalid-feedback").forEach(el => el.style.display = "none");
      document.getElementById("success-message").classList.add("d-none");
      document.getElementById("error-message").classList.add("d-none");
      let valid = true;
      if (nameInput.value.trim() === "") {
        nameInput.nextElementSibling.style.display = "block";
        valid = false;
      }
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(emailInput.value.trim())) {
        emailInput.nextElementSibling.style.display = "block";
        valid = false;
      }
      submitBtn.disabled = true;
      const formData = new FormData(formContact);
      const xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          submitBtn.disabled = false;
          if (xhr.status === 200) {
            formContact.reset();
            document.getElementById("success-message").classList.remove("d-none");
          } else {
            document.getElementById("error-message").classList.remove("d-none");
          }
        }
      };
      xhr.open("POST", "/contactsend", true);
      xhr.send(formData);
    });


  }


  const apportInput = document.getElementById("Apport");
  if (apportInput){
    const priceInput = document.getElementById("price");
    const capitalInput = document.getElementById("capital");
    const dureeInput = document.getElementById("duree");
    const tauxInput = document.getElementById("Taux");
    const montantEcheance = document.getElementById("montantEcheance");
    const montantTotalEmprunte = document.getElementById("montantTotalEmprunte");
    const montantTotalInterets = document.getElementById("montantTotalInterets");




    function calculer() {
      let price = parseFloat(priceInput.value) || 0;
      let apport = parseFloat(apportInput.value) || 0;
      let duree = parseInt(dureeInput.value) || 36;
      let taux = parseFloat(tauxInput.value) || 7;
      let capital = price - apport;
      capitalInput.value = capital;
      let tauxMensuel = (taux / 100) / 12;
      let nombreMois = duree;
      let mensualite = (capital * tauxMensuel) / (1 - Math.pow(1 + tauxMensuel, -nombreMois));
      let totalEmprunte = mensualite * nombreMois;
      let totalInterets = totalEmprunte - capital;
      montantEcheance.value = mensualite.toFixed(2);
      montantTotalEmprunte.value = totalEmprunte.toFixed(2);
      montantTotalInterets.value = totalInterets.toFixed(2);
    }
    [priceInput, apportInput, dureeInput, tauxInput].forEach(input => {
      input.addEventListener("input", calculer);
    });
    calculer();
  }


})()